var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInherited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4435_5817",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599609,
    y: 0.759766,
    width: 19.6,
    height: 19.6,
    rx: 4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4435_5817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.75 -3.14453C-6.75 -5.04732 -5.20748 -6.58984 -3.30469 -6.58984V-3.14453H-6.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.75 0.300781H-3.30469V3.74609H-6.75V0.300781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.75 7.19141H-3.30469V10.6367H-6.75V7.19141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.75 14.082H-3.30469V17.5273H-6.75V14.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.75 20.9727H-3.30469V24.418H-6.75V20.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30469 -3.14453H0.140625V0.300781H-3.30469V-3.14453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30469 3.74609H0.140625V7.19141H-3.30469V3.74609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30469 10.6367H0.140625V14.082H-3.30469V10.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30469 17.5273H0.140625V20.9727H-3.30469V17.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30469 24.418H0.140625V27.8633H-3.30469V24.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58594 -3.14453H7.03125V0.300781H3.58594V-3.14453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58594 3.74609H7.03125V7.19141H3.58594V3.74609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58594 10.6367H7.03125V14.082H3.58594V10.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58594 17.5273H7.03125V20.9727H3.58594V17.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58594 24.418H7.03125V27.8633H3.58594V24.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 -3.14453H13.9219V0.300781H10.4766V-3.14453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 3.74609H13.9219V7.19141H10.4766V3.74609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 10.6367H13.9219V14.082H10.4766V10.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 17.5273H13.9219V20.9727H10.4766V17.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 24.418H13.9219V27.8633H10.4766V24.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 -3.14453H20.8125V0.300781H17.3672V-3.14453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 3.74609H20.8125V7.19141H17.3672V3.74609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 10.6367H20.8125V14.082H17.3672V10.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 17.5273H20.8125V20.9727H17.3672V17.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 24.418H20.8125V27.8633H17.3672V24.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 -3.14453H27.7031V0.300781H24.2578V-3.14453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 3.74609H27.7031V7.19141H24.2578V3.74609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 10.6367H27.7031V14.082H24.2578V10.6367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 17.5273H27.7031V20.9727H24.2578V17.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 24.418H27.7031C27.7031 26.3208 26.1606 27.8633 24.2578 27.8633V24.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 -6.58984H3.58594V-3.14453H0.140625V-6.58984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 0.300781H3.58594V3.74609H0.140625V0.300781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 7.19141H3.58594V10.6367H0.140625V7.19141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 14.082H3.58594V17.5273H0.140625V14.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 20.9727H3.58594V24.418H0.140625V20.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 -6.58984H10.4766V-3.14453H7.03125V-6.58984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 0.300781H10.4766V3.74609H7.03125V0.300781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 7.19141H10.4766V10.6367H7.03125V7.19141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 14.082H10.4766V17.5273H7.03125V14.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 20.9727H10.4766V24.418H7.03125V20.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 -6.58984H17.3672V-3.14453H13.9219V-6.58984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 0.300781H17.3672V3.74609H13.9219V0.300781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 7.19141H17.3672V10.6367H13.9219V7.19141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 14.082H17.3672V17.5273H13.9219V14.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 20.9727H17.3672V24.418H13.9219V20.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 -6.58984H24.2578V-3.14453H20.8125V-6.58984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 0.300781H24.2578V3.74609H20.8125V0.300781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 7.19141H24.2578V10.6367H20.8125V7.19141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 14.082H24.2578V17.5273H20.8125V14.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 20.9727H24.2578V24.418H20.8125V20.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30469 -6.58984H0.140625V-3.14453H-3.30469V-6.58984Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30469 0.300781H0.140625V3.74609H-3.30469V0.300781Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30469 7.19141H0.140625V10.6367H-3.30469V7.19141Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30469 14.082H0.140625V17.5273H-3.30469V14.082Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.30469 20.9727H0.140625V24.418H-3.30469V20.9727Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.75 -3.14453H-3.30469V0.300781H-6.75V-3.14453Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.75 3.74609H-3.30469V7.19141H-6.75V3.74609Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.75 10.6367H-3.30469V14.082H-6.75V10.6367Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.75 17.5273H-3.30469V20.9727H-6.75V17.5273Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.75 24.418H-3.30469V27.8633C-5.20748 27.8633 -6.75 26.3208 -6.75 24.418Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 -3.14453H3.58594V0.300781H0.140625V-3.14453Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 3.74609H3.58594V7.19141H0.140625V3.74609Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 10.6367H3.58594V14.082H0.140625V10.6367Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 17.5273H3.58594V20.9727H0.140625V17.5273Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 24.418H3.58594V27.8633H0.140625V24.418Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 -3.14453H10.4766V0.300781H7.03125V-3.14453Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 3.74609H10.4766V7.19141H7.03125V3.74609Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 10.6367H10.4766V14.082H7.03125V10.6367Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 17.5273H10.4766V20.9727H7.03125V17.5273Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 24.418H10.4766V27.8633H7.03125V24.418Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 -3.14453H17.3672V0.300781H13.9219V-3.14453Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 3.74609H17.3672V7.19141H13.9219V3.74609Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 10.6367H17.3672V14.082H13.9219V10.6367Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 17.5273H17.3672V20.9727H13.9219V17.5273Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 24.418H17.3672V27.8633H13.9219V24.418Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 -3.14453H24.2578V0.300781H20.8125V-3.14453Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 3.74609H24.2578V7.19141H20.8125V3.74609Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 10.6367H24.2578V14.082H20.8125V10.6367Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 17.5273H24.2578V20.9727H20.8125V17.5273Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 24.418H24.2578V27.8633H20.8125V24.418Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58594 -6.58984H7.03125V-3.14453H3.58594V-6.58984Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58594 0.300781H7.03125V3.74609H3.58594V0.300781Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58594 7.19141H7.03125V10.6367H3.58594V7.19141Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58594 14.082H7.03125V17.5273H3.58594V14.082Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58594 20.9727H7.03125V24.418H3.58594V20.9727Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 -6.58984H13.9219V-3.14453H10.4766V-6.58984Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 0.300781H13.9219V3.74609H10.4766V0.300781Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 7.19141H13.9219V10.6367H10.4766V7.19141Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 14.082H13.9219V17.5273H10.4766V14.082Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 20.9727H13.9219V24.418H10.4766V20.9727Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 -6.58984H20.8125V-3.14453H17.3672V-6.58984Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 0.300781H20.8125V3.74609H17.3672V0.300781Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 7.19141H20.8125V10.6367H17.3672V7.19141Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 14.082H20.8125V17.5273H17.3672V14.082Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 20.9727H20.8125V24.418H17.3672V20.9727Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 -6.58984C26.1606 -6.58984 27.7031 -5.04732 27.7031 -3.14453H24.2578V-6.58984Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 0.300781H27.7031V3.74609H24.2578V0.300781Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 7.19141H27.7031V10.6367H24.2578V7.19141Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 14.082H27.7031V17.5273H24.2578V14.082Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 20.9727H27.7031V24.418H24.2578V20.9727Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.625 -0.464844L21.0301 21.1903",
    stroke: "#D80D0D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInherited);
export default __webpack_public_path__ + "static/media/inherited.6ff61b6be9a168e6323b9ee42c0af82b.svg";
export { ForwardRef as ReactComponent };